import React, { Component } from 'react';
import PropTypes from 'prop-types';

// 引入效果層
import ApiExceptionModal from '@js/components/Common/ApiExceptionModal';
import LoadingEffect from './LoadingEffect';

export default class EffectEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /** 關閉異常Modal */
  closeExceptionModal = () => {
    const {
      // func
      closeExceptionModal,
    } = this.props;

    closeExceptionModal();
  }

  render() {
    const {
      isLoading,
      isShowExceptionModal,
      apiExceptionMessage,
    } = this.props;
    return (
      <>
        <LoadingEffect isLoading={isLoading} />
        <ApiExceptionModal
          isShowExceptionModal={isShowExceptionModal}
          apiExceptionMessage={apiExceptionMessage}
          closeExceptionModal={this.closeExceptionModal}
        />
      </>
    );
  }
}

EffectEntry.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
